import { PaginatorOptions } from '@tripointe/tripointe-cms/types';

export const DEFAULT_PAGINATION_OPTIONS: PaginatorOptions = {
  length: 0,
  pageSize: 10,
  pageIndex: 0,
  previousPageIndex: 0
};
